//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let checkPhone = (rule, value, callback) => {
  var reg = /^1\d{10}$/; //手机号
  if (!reg.test(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
};
let checkPassword = (rule, value, callback) => {
  let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入6-20个字母、数字和符号两种及以上的组合字符"));
  } else {
    callback();
  }
};
export default {
  layout: "signUp",
  head() {
    return {
      title: "用户注册中心-飙局",
      meta: [
        {
          name: "description",
          content: ""
        },
        {
          name: "keywords",
          content: ""
        }
      ]
    };
  },
  data() {
    return {
      showModel: false,
      registerRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        verifyCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ],
        pwd: [
          { required: true, message: "请设置密码", trigger: "blur" },
          { validator: checkPassword, trigger: "blur" }
        ],
        picCode: [
          { required: true, message: "请输入图形验证码计算结果", trigger: "blur" }
        ]
      },
      registerForm: {
        phone: null,
        verifyCode: null,
        pwd: null,
        picCode: null
      },
      picCodeUrl: null,
      showSuccess: false,
      checkList: [],
      countDown: 0,
      userName: "",
      loginOK: false,
      isRepeat: false,
      interval: null,
      btnText:"获取验证码"
    };
  },
  async asyncData({ error, query, $axios, params }) {
    try {
      const [res] = await Promise.all([$axios.get("/api/Auth/initRegistor")]);
      if (res && res.data && res.data.data) {
        console.log(res.data.data);
        return {
          initData: res.data.data
        };
      }
    } catch (err) {
      error(err);
    }
  },
  mounted() {},
  created() {
    this.getPicCode();
  },
  methods: {
    goLogin() {
      if (!this.loginOK) {
        this.$axios
          .post("/api/Auth/login", {
            account: this.userName,
            secret: this.registerForm.pwd,
            way: 2
          })
          .then(res => {
            if (res.data.code == 0) {
              this.loginOK = true;
              this.$axios.post("/api/auth/getUserInfo").then(res => {
                this.$store.commit("setUser", res.data.data);
              });
              setTimeout(() => {
                this.$router.push("/");
              }, 2000);
            } else {
              if(res.data.code == -9100) return false;
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    submitForm() {
      if (!this.isRepeat) {
        this.isRepeat = true;
        setTimeout(() => {
          this.isRepeat = false;
        }, 2000);

        this.$refs.registerRules.validate(valid => {
          if (valid) {
            const loading = this.$loading();
            this.$axios
              .post("/api/Auth/registor", this.registerForm)
              .then(res => {
                loading.close();
                if (res.data.code == 0) {
                  this.showSuccess = true;
                  this.userName = res.data.data.username;
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          }
        });
      }
    },
    getPicCode() {
      this.$axios.get("/api/Auth/graphVerifyCode").then(res => {
        this.picCodeUrl = res.data;
      });
    },
    getMobileCode() {
      //scene 场景1=注册，2=验证码登录，3=找回密码手机验证5=更换手机号之验证旧手机，6=更换手机号之验证新手机 默认2
      this.$refs.registerRules.validateField(["phone"], phoneMsg => {
        if (!phoneMsg) {
          this.$refs.registerRules.validateField(["picCode"], picCodeMsg => {
            if (!picCodeMsg) {
              if (!this.isRepeat) {
                this.isRepeat = true;
                setTimeout(() => {
                  this.isRepeat = false;
                }, 2000);
                if (this.countDown > 0) {
                  return;
                }

                this.$axios
                  .post("/api/Auth/mobileVerifyCode", {
                    phone: this.registerForm.phone,
                    graphCode: this.registerForm.picCode,
                    scene: 1
                  })
                  .then(res => {
                    if (res.data.code == 0) {
                      this.$message({
                        message: "获取成功，请留意手机短信",
                        type: "success"
                      });
                      this.countDown = 60;
                      this.btnText="重发验证码";
                      this.interval = setInterval(() => {
                        if (this.countDown > 0) {
                          this.countDown--;
                          console.log(this.countDown);
                        } else {
                          clearInterval(this.interval);
                          this.interval = null;
                        }
                      }, 1000);
                    } else {
                      this.getPicCode();
                      this.$message.error(res.data.msg);
                    }
                  });
              }
            }
          });
        }
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = null;
  }
};
